import * as Sentry from '@sentry/browser';

let sessionInfo;
export default function getSessionInfo() {
  if (sessionInfo === undefined) {
    try {
      const encodedSession = window.getEncodedSessionInfo();
      if (encodedSession) {
        sessionInfo = JSON.parse(atob(encodedSession));
      }
    } catch (e) {
      Sentry.captureException(new Error(`Session decode failed: ${e?.message}`));
    }
  }
  return sessionInfo || {
    brand: {
      id: 'default',
      name: 'default',
      category: 'default',
    },
    staticPlansAndAddons: {
      plans: [],
    },
    leadInfo: {},
    account: {},
  };
}

let braintreeClientToken;

export function getBraintreeClientToken() {
  return braintreeClientToken;
}

export function setBraintreeClientToken(btClientToken) {
  braintreeClientToken = btClientToken;
}

let errorInfo;
export function getErrorInfoFromSession() {
  try {
    if (
      errorInfo === undefined
  && typeof window.getEncodedErrorInfo === 'function'
    ) {
      const encodedErrorInfo = window.getEncodedErrorInfo();
      if (encodedErrorInfo && encodedErrorInfo.trim() !== '') {
        errorInfo = JSON.parse(atob(encodedErrorInfo));
      }
    }
  } catch (e) {
    const err = new Error(`Failed to decode error info from session : ${e?.message}`);
    err.name = 'ErrorInfoDecodeError';
    err.cause = e;
    Sentry.captureException(err);
  }
  return errorInfo || {};
}

export const isMobileScreen = () => {
  const maxWidth = 1024;
  return typeof window !== 'undefined' && window.innerWidth <= maxWidth;
};
